import React, { useContext, useState } from 'react'
import { AppContext } from '../../Context'
import { MemoryRouter, Route, Switch, useHistory } from 'react-router'
import SimulationForm from './SimulationForm'
import SimulationFailed from './SimulationFailed'
import SimulationSuccess from './SimulationSuccess'

export const SimulationContext = React.createContext({})

function SimulationPage({ simulationOnly = false, ...props }) {
  const { employee } = useContext(AppContext)
  const [simulation, setSimulation] = useState({})
  const history = useHistory()

  return employee ? (
    <MemoryRouter>
      <SimulationContext.Provider value={ { simulation, setSimulation, parentHistory: history, simulationOnly } }>
        <Switch>
          <Route path={ '/' } exact={ true } component={ SimulationForm }/>
          <Route path={ '/success' } component={ SimulationSuccess }/>
          <Route path={ '/failed' } component={ SimulationFailed }/>
        </Switch>
      </SimulationContext.Provider>
    </MemoryRouter>
  ) : null
}

export default SimulationPage
